const locationsUrl = `https://www.muddybites.com/cdn/shop/t/44/assets/locations2.geojson?v=${Math.ceil(Math.random() * 45612309)}`
const locationsTestingUrl = 'https://cdn.shopify.com/s/files/1/0022/1750/8973/t/46/assets/locations-mapbox-testing.geojson?randomNum=1'
mapboxgl.accessToken = 'pk.eyJ1IjoiZWNvbWdyYWR1YXRlcyIsImEiOiJjbGJ3aWxkeGowNDdpM25tbmVya2RqeTJnIn0.Mjs1jqCodkbKsfNTjmSs9Q'
let lngLat = [-98.35, 39.50]

const map = new mapboxgl.Map({
    container: 'map',
    style: 'mapbox://styles/mapbox/streets-v11',
    center: lngLat,
    zoom: 6,
    scrollZoom: false
})

map.addControl(new mapboxgl.NavigationControl())

const geocoder = new MapboxGeocoder({
    accessToken: mapboxgl.accessToken,
    mapboxgl
})
map.addControl(geocoder)

const geolocate = new mapboxgl.GeolocateControl()
map.addControl(geolocate)

geocoder.on('result', (event) => {
    console.log(event)
    lngLat = event.result.geometry
    initLocationsData()
})

geolocate.on('geolocate', (event) => {
    lngLat = [event.coords.longitude, event.coords.latitude]
    initLocationsData()
})

const initLocationsData = async () => {
    const response = await fetch(locationsUrl)
    const data = await response.json()

    let locations = data.features.map(location => {
        const distance = Math.round(turf.distance(location.geometry.coordinates, lngLat))
        return { ...location, distance }
    })

    locations = locations.sort((a, b) => a.distance - b.distance)

    console.log(locations)

    document.querySelector('#map-card .card-header span').textContent = locations.length

    let listItems = ''

    locations.forEach((location, index) => {
      console.log(index, location)
        listItems += `
            <li class="">
                <button 
                    class=""
                    data-index="${index}">
                    <div class="d-flex align-items-center">
                        <div class="me-3 flex-grow-1">
                            <span class="title fw-bold d-block mb-1">
                                ${location.properties.title.trim()}
                            </span>
                            <span class="description d-block mb-1">
                                ${location.properties.description.replace(/^\s+|\s+$/g,'')}
                            </span>
                            <span class="badge-distance badge">
                               ${location.distance} miles away
                            </span>
                        </div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round">
                            <circle cx="12" cy="12" r="10"/><path d="M12 8l4 4-4 4M8 12h7"/>
                        </svg>
                    </div>
                </button>
            </li>
        `
    })

    document.querySelector('#store-locations-list').innerHTML = ''
    document.querySelector('#store-locations-list').insertAdjacentHTML('afterbegin', listItems)

    // for (const feature of locations) {
    //     const el = document.createElement('div')
    //     el.className = 'mapbox-marker'

    //     new mapboxgl.Marker(el)
    //         .setLngLat(feature.geometry.coordinates)
    //         .setPopup(
    //             new mapboxgl.Popup({ offset: 25 })
    //                 .setHTML(`
    //                     <p class="title">${feature.properties.title}</p>
    //                     <p>${feature.properties.description}</p>
    //                     <a href="" class="">Get Directions</a>
    //                 `)
    //         )
    //         .addTo(map)
    // }

    map.on('load', () => {
        // Add a new source from our GeoJSON data and
        // set the 'cluster' option to true. GL-JS will
        // add the point_count property to your source data.
        map.addSource('muddyLocations', {
            type: 'geojson',
            // Point to GeoJSON data. This example visualizes all M1.0+ earthquakes
            // from 12/22/15 to 1/21/16 as logged by USGS' Earthquake hazards program.
            // data: 'https://docs.mapbox.com/mapbox-gl-js/assets/earthquakes.geojson',
            data: locationsUrl,
            cluster: true,
            clusterMaxZoom: 14, // Max zoom to cluster points on
            clusterRadius: 50 // Radius of each cluster when clustering points (defaults to 50)
        })

        map.addLayer({
            id: 'clusters',
            type: 'circle',
            source: 'muddyLocations',
            filter: ['has', 'point_count'],
            paint: {
                // Use step expressions (https://docs.mapbox.com/mapbox-gl-js/style-spec/#expressions-step)
                // with three steps to implement three types of circles:
                'circle-color': [
                    'step',
                    ['get', 'point_count'],
                    '#3087dc',
                    100,
                    '#1f6eba',
                    500,
                    '#18548e'
                ],
                'circle-radius': [
                    'step',
                    ['get', 'point_count'],
                    20,
                    100,
                    30,
                    500,
                    40
                ]
            }
        })

        map.addLayer({
            id: 'cluster-count',
            type: 'symbol',
            source: 'muddyLocations',
            filter: ['has', 'point_count'],
            layout: {
                'text-field': ['get', 'point_count_abbreviated'],
                'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
                'text-size': 12
            },
            paint: {
                'text-color': '#ffffff'
            }
        })

        map.addLayer({
            id: 'unclustered-point',
            type: 'circle',
            source: 'muddyLocations',
            filter: ['!', ['has', 'point_count']],
            paint: {
                'circle-color': '#3B8EDE',
                'circle-radius': 10,
                'circle-stroke-width': 2,
                'circle-stroke-color': '#fff'
            }
        })

        // inspect a cluster on click
        map.on('click', 'clusters', (e) => {
            const features = map.queryRenderedFeatures(e.point, {
                layers: ['clusters']
            })
            const clusterId = features[0].properties.cluster_id
            map.getSource('muddyLocations').getClusterExpansionZoom(
                clusterId,
                (err, zoom) => {
                    if (err) return
                    map.easeTo({
                        center: features[0].geometry.coordinates,
                        zoom
                    })
                }
            )
        })

        // When a click event occurs on a feature in
        // the unclustered-point layer, open a popup at
        // the location of the feature, with
        // description HTML from its properties.
        map.on('click', 'unclustered-point', (e) => {
            console.log(e)
            const feature = e.features[0]
            const coordinates = feature.geometry.coordinates.slice()

            // Ensure that if the map is zoomed out such that
            // multiple copies of the feature are visible, the
            // popup appears over the copy being pointed to.
            while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360
            }

            new mapboxgl.Popup({ offset: 10 })
                .setLngLat(coordinates)
                .setHTML(`
                    <p class="title">${feature.properties.title.trim()}</p>
                    <p>${feature.properties.description.trim()}</p>
                    <a href="https://www.google.com/maps/dir/${feature.properties.description}" target="_blank">
                        Get Directions
                    </a>
                `)
                .addTo(map)
        })

        map.on('mouseenter', 'clusters', () => {
            map.getCanvas().style.cursor = 'pointer'
        })
        map.on('mouseleave', 'clusters', () => {
            map.getCanvas().style.cursor = ''
        })
    })

    document.querySelectorAll('#store-locations-list button').forEach(btn => {
        btn.addEventListener('click', (e) => {
            document.querySelectorAll('#store-locations-list button').forEach(btn => {
                btn.classList.remove('active')
            })

            btn.classList.add('active')

            const location = locations[Number(btn.dataset.index)]

            map.flyTo({
                center: location.geometry.coordinates,
                zoom: 14
            })

            document.querySelectorAll('.mapboxgl-popup').forEach((popup) => {
                popup.remove()
            })

            new mapboxgl.Popup({ offset: 10 })
                .setLngLat(location.geometry.coordinates)
                .setHTML(`
                    <p class="title">${location.properties.title.trim()}</p>
                    <p>${location.properties.description.trim()}</p>
                    <a 
                        href="https://www.google.com/maps/dir/${location.properties.description}" 
                        target="_blank"
                        class="text-decoration-underline">
                        Get Directions
                    </a>
                `)
                .addTo(map)
        })
    })
}
initLocationsData()
